export class GiftCardItem {
    cardnumber: string;
    pin: string;
    balance: number;
}
